import {
  range_styles_default
} from "./chunk.EC5FK3SF.js";
import {
  SlRange
} from "./chunk.NLSMO2SV.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/range/range.ts
var FadvRange = class extends SlRange {
};
FadvRange.styles = range_styles_default;
FadvRange = __decorateClass([
  n("fadv-range")
], FadvRange);

export {
  FadvRange
};
